import { QuoteUnderwritingTaskPatchRequestBody } from '@lio/api-types';
import { useQueryClient, useMutation } from '@tanstack/react-query';
import { useClient } from '@utils/api-client';

export const useUpdateTask = (quoteId: string | undefined, underwriterTaskId: string | undefined) => {
  const client = useClient();
  const queryClient = useQueryClient();

  const mutationFn = ({ status, underwriterDisposition, underwriterComment }: QuoteUnderwritingTaskPatchRequestBody) =>
    client.patch(`quote/${quoteId}/underwriting-task/${underwriterTaskId}`, {
      json: {
        status,
        underwriterDisposition,
        underwriterComment,
      },
    });

  const result = useMutation({
    mutationFn,
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['underwritingTasks'] }),
  });
  return { ...result, updateTask: result.mutateAsync };
};
